<template>
  <svg width="34"
       height="35"
       viewBox="0 0 34 35"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <circle cx="17"
            cy="17.5"
            r="17"
            fill="#FFBE15"
            fill-opacity="0.12" />
    <circle cx="17" cy="17" r="10" fill="#FFBE15" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2002 14.6C12.2002 14.3878 12.2845 14.1843 12.4345 14.0343C12.5845 13.8843 12.788 13.8 13.0002 13.8H21.0002C21.2124 13.8 21.4159 13.8843 21.5659 14.0343C21.7159 14.1843 21.8002 14.3878 21.8002 14.6C21.8002 14.8122 21.7159 15.0157 21.5659 15.1657C21.4159 15.3157 21.2124 15.4 21.0002 15.4H13.0002C12.788 15.4 12.5845 15.3157 12.4345 15.1657C12.2845 15.0157 12.2002 14.8122 12.2002 14.6ZM12.2002 19.4C12.2002 19.1878 12.2845 18.9843 12.4345 18.8343C12.5845 18.6843 12.788 18.6 13.0002 18.6H21.0002C21.2124 18.6 21.4159 18.6843 21.5659 18.8343C21.7159 18.9843 21.8002 19.1878 21.8002 19.4C21.8002 19.6122 21.7159 19.8157 21.5659 19.9657C21.4159 20.1157 21.2124 20.2 21.0002 20.2H13.0002C12.788 20.2 12.5845 20.1157 12.4345 19.9657C12.2845 19.8157 12.2002 19.6122 12.2002 19.4Z"
      fill="white" />
  </svg>
</template>
<script>
export default {
  props: {}
}
</script>
